export default __webpack_public_path__ + "static/3-a648797c1ed67929a89ce3c22a7547b6.png";